/* LUMINA case study v2: reveal on scroll, count up, charts, progress line, marquee, timeline, FAQ, lead form. */
(function () {
  if (window.__cs2) return;
  window.__cs2 = true;

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var design = !!(window.Shopify && window.Shopify.designMode);
  var still = reduce || design;
  var io = null;
  if (!still && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        if (ents[i].isIntersecting) { ents[i].target.classList.remove('cs2-hide'); io.unobserve(ents[i].target); }
      }
    }, { threshold: 0.1 });
  }

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* Count up a number from 0 */
  function count(el) {
    if (el.__cs2c) return;
    el.__cs2c = true;
    var to = parseFloat(el.getAttribute('data-count'));
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var pre = el.getAttribute('data-pre') || '';
    var suf = el.getAttribute('data-suf') || '';
    if (isNaN(to) || still) return;
    var t0 = null, dur = 1600;
    function tick(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var k = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + (to * k).toFixed(dec) + suf;
      if (p < 1) window.requestAnimationFrame(tick);
    }
    el.textContent = pre + (0).toFixed(dec) + suf;
    window.requestAnimationFrame(tick);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.cs2');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (root.__cs2) continue;
      root.__cs2 = true;
      if (!still) root.classList.add('cs2-js');
      var vh = window.innerHeight;
      if (io) {
        $all(root, '[data-rv]').forEach(function (el) {
          if (el.getBoundingClientRect().top < vh) return;
          el.classList.add('cs2-hide');
          io.observe(el);
        });
      }
      var hero = root.classList.contains('cs2-hero') ? root : root.querySelector('.cs2-hero');
      if (hero) window.setTimeout(function (h) { return function () { h.classList.add('is-in'); }; }(hero), 60);
      $all(root, '.cs2-tl').forEach(timeline);
      $all(root, '.cs2-faq__list').forEach(faq);
      $all(root, '.cs2-f').forEach(form);
      $all(root, '.cs2-mq__row').forEach(function (row) {
        if (row.__cs2d) return;
        row.__cs2d = true;
        var html = row.innerHTML;
        row.innerHTML = html + html + html;
      });
    }
    frame();
  }

  /* Everything driven by the scroll position */
  var ticking = false;
  function frame() {
    var doc = document.scrollingElement || document.documentElement;
    var y = window.pageYOffset || doc.scrollTop || 0;
    var vh = window.innerHeight || 1;
    var max = doc.scrollHeight - doc.clientHeight;
    var p = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
    $all(document, '.cs2-prog').forEach(function (b) { b.style.setProperty('--cs2-p', p.toFixed(4)); });

    $all(document, '.cs2-hero').forEach(function (h) {
      h.style.setProperty('--cs2-hy', (still ? 0 : Math.min(y * 0.25, 240)) + 'px');
    });

    $all(document, '[data-on]').forEach(function (el) {
      if (el.classList.contains('is-on')) return;
      var f = parseFloat(el.getAttribute('data-on')) || 0.7;
      if (el.getBoundingClientRect().top < vh * f) {
        el.classList.add('is-on');
        $all(el, '[data-count]').forEach(count);
      }
    });

    if (!still) {
      var shift = y * 0.45;
      $all(document, '.cs2-mq__row').forEach(function (row, i) {
        var odd = i % 2;
        var x = (odd ? 1 : -1) * (shift % 1600) - (odd ? 1800 : 400);
        row.style.transform = 'translate3d(' + x + 'px,0,0)';
      });
    } else {
      $all(document, '.cs2-mq__row').forEach(function (row, i) {
        row.style.transform = 'translate3d(' + (i % 2 ? -1800 : -400) + 'px,0,0)';
      });
    }

    $all(document, '.cs2-tl').forEach(function (tl) { if (!tl.__cs2lock) setStep(tl, stepFor(tl, vh)); });
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; frame(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* Timeline of changes with the sticky panel */
  function stepFor(tl, vh) {
    var s = 0;
    $all(tl, 'li[data-step]').forEach(function (li, i) { if (li.getBoundingClientRect().top < vh * 0.5) s = i; });
    return s;
  }
  function setStep(tl, s) {
    if (tl.__cs2s === s) return;
    tl.__cs2s = s;
    var items = $all(tl, 'li[data-step]');
    var sec = tl.closest('.cs2-chg');
    items.forEach(function (li, i) {
      li.classList.toggle('is-act', i === s);
      li.classList.toggle('is-past', i < s);
    });
    tl.style.setProperty('--rail', ((s + 0.5) / Math.max(1, items.length) * 100).toFixed(1) + '%');
    if (!sec) return;
    $all(sec, '.cs2-sp__pane').forEach(function (p, i) { p.classList.toggle('is-act', i === s); });
    $all(sec, '.cs2-sp__title').forEach(function (t, i) { t.hidden = i !== s; });
    $all(sec, '.cs2-sp__nav button').forEach(function (b, i) {
      b.classList.toggle('is-act', i === s);
      b.classList.toggle('is-past', i < s);
    });
  }
  function timeline(tl) {
    if (tl.__cs2t) return;
    tl.__cs2t = true;
    var sec = tl.closest('.cs2-chg');
    tl.__cs2s = -1;
    setStep(tl, 0);
    if (!sec) return;
    $all(sec, '.cs2-sp__nav button').forEach(function (b, i) {
      b.addEventListener('click', function () {
        var li = $all(tl, 'li[data-step]')[i];
        if (!li) return;
        var doc = document.scrollingElement || document.documentElement;
        var top = doc.scrollTop + li.getBoundingClientRect().top - window.innerHeight * 0.3;
        window.scrollTo({ top: top, behavior: still ? 'auto' : 'smooth' });
        setStep(tl, i);
      });
    });
  }

  /* FAQ: one answer open at a time */
  function faq(list) {
    if (list.__cs2f) return;
    list.__cs2f = true;
    $all(list, '.cs2-q__b').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.closest('.cs2-q');
        var open = !q.classList.contains('is-open');
        $all(list, '.cs2-q').forEach(function (x) {
          x.classList.remove('is-open');
          var b = x.querySelector('.cs2-q__b');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (open) { q.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* Lead form */
  var COUNTRIES = [['ae','United Arab Emirates','+971'],['sa','Saudi Arabia','+966'],['kw','Kuwait','+965'],['qa','Qatar','+974'],['bh','Bahrain','+973'],['om','Oman','+968'],['lb','Lebanon','+961'],['jo','Jordan','+962'],['eg','Egypt','+20'],['gb','United Kingdom','+44'],['fr','France','+33'],['us','United States','+1']];
  function flag(c) { return 'url(https://flagcdn.com/w40/' + c + '.png)'; }
  function detect() {
    try {
      var known = window.localStorage.getItem('lumina_country') || '';
      var hit = /\(([A-Za-z]{2})\)\s*$/.exec(known);
      if (hit) {
        var iso = hit[1].toLowerCase();
        for (var i = 0; i < COUNTRIES.length; i++) if (COUNTRIES[i][0] === iso) return iso;
      }
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      var map = { Dubai: 'ae', Riyadh: 'sa', Kuwait: 'kw', Qatar: 'qa', Bahrain: 'bh', Muscat: 'om', Beirut: 'lb', Amman: 'jo', Cairo: 'eg', London: 'gb', Paris: 'fr', New_York: 'us', Chicago: 'us', Los_Angeles: 'us', Denver: 'us' };
      for (var k in map) if (tz.slice(-k.length) === k) return map[k];
    } catch (e) {}
    return 'ae';
  }
  function pick(obj, path) {
    var parts = path.split('.'), cur = obj;
    for (var i = 0; i < parts.length; i++) {
      if (cur === null || cur === undefined) return '';
      cur = cur[parts[i]];
    }
    return cur === null || cur === undefined ? '' : cur;
  }
  function form(f) {
    if (f.__cs2form) return;
    f.__cs2form = true;
    var box = f.querySelector('.cs2-ph');
    var dial = '+971';
    if (box) {
      var btn = box.querySelector('.cs2-ph__btn');
      var menu = box.querySelector('.cs2-ph__menu');
      var fl = box.querySelector('.cs2-ph__btn .cs2-flag');
      var dl = box.querySelector('.cs2-ph__dial');
      var input = box.querySelector('input[type="tel"]');
      var set = function (iso) {
        for (var i = 0; i < COUNTRIES.length; i++) {
          if (COUNTRIES[i][0] !== iso) continue;
          dial = COUNTRIES[i][2];
          fl.style.backgroundImage = flag(iso);
          fl.setAttribute('aria-label', COUNTRIES[i][1]);
          dl.textContent = dial;
          $all(menu, '.cs2-ph__opt').forEach(function (o) { o.classList.toggle('is-sel', o.getAttribute('data-iso') === iso); });
        }
      };
      menu.innerHTML = COUNTRIES.map(function (c) {
        return '<button type="button" class="cs2-ph__opt" data-iso="' + c[0] + '"><span class="cs2-flag" aria-hidden="true" style="background-image:' + flag(c[0]) + '"></span><span>' + c[1] + '</span><span>' + c[2] + '</span></button>';
      }).join('');
      set(detect());
      btn.addEventListener('click', function () {
        var open = menu.hidden;
        menu.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      menu.addEventListener('click', function (ev) {
        var o = ev.target.closest ? ev.target.closest('.cs2-ph__opt') : null;
        if (!o) return;
        set(o.getAttribute('data-iso'));
        menu.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        input.focus();
      });
      document.addEventListener('click', function (ev) { if (!box.contains(ev.target)) { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });
      input.addEventListener('input', function () {
        var v = input.value.replace(/\s/g, '');
        if (v.charAt(0) !== '+') return;
        var sorted = COUNTRIES.slice().sort(function (a, b) { return b[2].length - a[2].length; });
        for (var i = 0; i < sorted.length; i++) {
          if (v.indexOf(sorted[i][2]) === 0) { set(sorted[i][0]); input.value = v.slice(sorted[i][2].length); return; }
        }
      });
    }

    var msgs = {
      name: f.getAttribute('data-e-name'), email: f.getAttribute('data-e-email'), email2: f.getAttribute('data-e-email2'),
      phone: f.getAttribute('data-e-phone'), phone2: f.getAttribute('data-e-phone2'), website: f.getAttribute('data-e-site'),
      website2: f.getAttribute('data-e-site2'), services: f.getAttribute('data-e-svc')
    };
    var tried = false;
    function field(name) { return f.querySelector('[data-f="' + name + '"]'); }
    function val(name) { var el = f.querySelector('[data-v="' + name + '"]'); return el ? el.value.trim() : ''; }
    function errors() {
      var er = {};
      if (field('name') && !val('name')) er.name = msgs.name;
      var em = val('email');
      if (!em) er.email = msgs.email; else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) er.email = msgs.email2;
      if (field('phone')) {
        var d = val('phone').replace(/\D/g, '');
        if (!d) er.phone = msgs.phone; else if (d.length < 7 || d.length > 12) er.phone = msgs.phone2;
      }
      if (field('website')) {
        var w = val('website');
        if (!w) er.website = msgs.website; else if (!/^(https?:\/\/)?[^\s.]+\.[^\s]{2,}$/i.test(w)) er.website = msgs.website2;
      }
      if (field('services') && !f.querySelectorAll('[data-svc]:checked').length) er.services = msgs.services;
      return er;
    }
    function paint() {
      var er = tried ? errors() : {};
      ['name', 'email', 'phone', 'website', 'services'].forEach(function (k) {
        var fd = field(k);
        if (!fd) return;
        fd.classList.toggle('is-err', !!er[k]);
        var out = fd.querySelector('.cs2-err');
        if (out) out.textContent = er[k] || '';
        var ph = fd.querySelector('.cs2-ph');
        if (ph) ph.classList.toggle('is-err', !!er[k]);
      });
      var n = Object.keys(er).length;
      var al = f.querySelector('.cs2-alert');
      if (al) {
        al.hidden = !n;
        var t = al.querySelector('span');
        if (t) t.textContent = n === 1 ? f.getAttribute('data-e-one') : (n + ' ' + f.getAttribute('data-e-many'));
      }
      return n;
    }
    f.addEventListener('input', function () { if (tried) paint(); });
    f.addEventListener('change', function () { if (tried) paint(); });
    /* Check the fields when the button is pressed (Enter in a field presses it too), before the store's own form scripts run. */
    var t0 = Date.now();
    function check(ev) {
      tried = true;
      var hp = f.querySelector('[data-hp]');
      if (hp && hp.value) { ev.preventDefault(); if (ev.stopImmediatePropagation) ev.stopImmediatePropagation(); return false; }
      if (paint()) {
        ev.preventDefault();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        var first = f.querySelector('.is-err');
        if (first) first.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
        return false;
      }
      prepare();
      return true;
    }
    var sub = f.querySelector('button[type="submit"]');
    if (sub) sub.addEventListener('click', check);
    f.addEventListener('submit', function (ev) { if (!f.__cs2ok) check(ev); }, true);
    function prepare() {
      f.__cs2ok = true;
      var sc = f.querySelector('[data-sc]');
      if (sc) { var secs = Math.round((Date.now() - t0) / 1000); sc.value = secs < 5 ? 'suspicious: sent in ' + secs + 's' : 'passed (' + secs + 's on page)'; }
      var svc = $all(f, '[data-svc]:checked').map(function (c) { return c.value; }).join(', ');
      var hs = f.querySelector('[data-hidden="services"]');
      if (hs) hs.value = svc;
      var tel = f.querySelector('input[type="tel"]');
      if (tel) {
        var num = tel.value.trim();
        if (num !== '' && num.charAt(0) !== '+') tel.value = dial + ' ' + num.replace(/^0+/, '');
      }
      var T = window.LUMINA_TRACKING;
      if (!T) return;
      var begin = 0;
      try { begin = parseInt(window.sessionStorage.getItem('lumina_session_start') || Date.now(), 10); } catch (e) { begin = Date.now(); }
      var secs = Math.max(0, Math.floor((Date.now() - begin) / 1000));
      $all(f, 'input[data-lt]').forEach(function (h) {
        var key = h.getAttribute('data-lt');
        var v = key === '@duration' ? Math.floor(secs / 60) + ' min ' + (secs % 60) + ' sec' : pick(T, key);
        h.value = v === '' ? '(not set)' : v;
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})();
